export interface MovieItem {
  id: string;
  title: string;
  englishTitle: string;
  coverImage: string;
  rating: number;
  year: number;
  category: string;
  tags: string[];
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
}

export const heroMovies: MovieItem[] = [
  {
    id: "movie-1",
    title: "流浪地球3",
    englishTitle: "The Wandering Earth 3",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20massive%20planetary%20engines%20glowing%20in%20deep%20space%2C%20epic%20cinematic%20lighting%2C%20dramatic%20orange%20and%20gold%20tones%2C%20grand%20scale%20with%20tiny%20spaceships%2C%20movie%20poster%20style%20composition%2C%20high%20contrast%20dramatic%20shadows&width=800&height=450&seq=hero-movie-1&orientation=landscape",
    rating: 8.5,
    year: 2026,
    category: "movie",
    tags: ["科幻", "冒险", "灾难"],
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器寻找新家园。面对未知的宇宙旅程，年轻一代挺身而出展开争分夺秒的生死之战。",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    duration: "173分钟",
    region: "中国大陆",
    isHot: true,
    isNew: true,
    views: 12800000,
  },
  {
    id: "movie-2",
    title: "封神第二部",
    englishTitle: "Creation of the Gods II",
    coverImage: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20film%20with%20ancient%20warriors%20in%20ornate%20armor%20riding%20mythical%20beasts%2C%20golden%20palace%20in%20background%2C%20dramatic%20stormy%20sky%2C%20cinematic%20movie%20poster%20style%2C%20rich%20warm%20gold%20and%20crimson%20tones&width=800&height=450&seq=hero-movie-2&orientation=landscape",
    rating: 8.0,
    year: 2026,
    category: "movie",
    tags: ["神话", "奇幻", "动作"],
    description: "殷商大军兵临西岐，姜子牙率昆仑仙人驰援。姬发带领西岐军民奋勇抵抗，一场惊天动地的神魔大战即将爆发。",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适"],
    duration: "148分钟",
    region: "中国大陆",
    isHot: true,
    isNew: true,
    views: 9650000,
  },
  {
    id: "movie-3",
    title: "哪吒之魔童闹海",
    englishTitle: "Nezha: The Devil's Revenge",
    coverImage: "https://readdy.ai/api/search-image?query=Animated%20Chinese%20fantasy%20film%20with%20a%20young%20hero%20wielding%20a%20fire-tipped%20spear%20riding%20wind%20fire%20wheels%20over%20turbulent%20ocean%20waves%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20epic%20scale%2C%20cinematic%20lighting%20with%20dramatic%20clouds&width=800&height=450&seq=hero-movie-3&orientation=landscape",
    rating: 8.3,
    year: 2025,
    category: "movie",
    tags: ["动画", "神话", "喜剧"],
    description: "天劫之后哪吒与敖丙灵魂虽保住但肉身濒临消散，太乙真人欲用七色宝莲为二人重塑肉身，却遭遇重重困难。",
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    duration: "110分钟",
    region: "中国大陆",
    isHot: true,
    isNew: false,
    views: 18500000,
  },
  {
    id: "movie-4",
    title: "热辣滚烫",
    englishTitle: "YOLO",
    coverImage: "https://readdy.ai/api/search-image?query=Inspirational%20Chinese%20drama%20film%20about%20boxing%2C%20a%20woman%20training%20in%20a%20dimly%20lit%20gym%20with%20boxing%20gloves%2C%20sweat%20and%20determination%2C%20warm%20amber%20lighting%2C%20cinematic%20movie%20poster%20composition%2C%20intimate%20and%20powerful%20mood&width=800&height=450&seq=hero-movie-4&orientation=landscape",
    rating: 7.8,
    year: 2024,
    category: "movie",
    tags: ["剧情", "喜剧", "励志"],
    description: "乐莹宅家多年无所事事，在经历一系列挫折后，她结识了拳击教练昊坤，生活由此发生翻天覆地的变化。",
    director: "贾玲",
    actors: ["贾玲", "雷佳音", "张小斐"],
    duration: "129分钟",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 15600000,
  },
];

export const categoryMovies: MovieItem[] = [
  {
    id: "movie-5",
    title: "志愿军：存亡之战",
    englishTitle: "The Volunteers: To the War 2",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20war%20film%20with%20soldiers%20in%20battlefield%2C%20dramatic%20explosions%20and%20smoke%2C%20heroic%20posing%2C%20cinematic%20movie%20poster%20style%2C%20muted%20olive%20and%20earth%20tones%2C%20epic%20scale&width=400&height=560&seq=cat-movie-5&orientation=portrait",
    rating: 8.7,
    year: 2025,
    category: "movie",
    tags: ["战争", "历史", "剧情"],
    description: "1950年抗美援朝战争进入最关键的阶段，志愿军战士们在极端恶劣的条件下浴血奋战。",
    director: "陈凯歌",
    actors: ["朱一龙", "张子枫", "辛柏青"],
    duration: "156分钟",
    region: "中国大陆",
    isHot: true,
    isNew: false,
    views: 11200000,
  },
  {
    id: "movie-6",
    title: "奥本海默",
    englishTitle: "Oppenheimer",
    coverImage: "https://readdy.ai/api/search-image?query=Biographical%20drama%20film%20with%20a%20serious%20man%20in%20suit%20and%20fedora%20hat%20against%20nuclear%20explosion%20mushroom%20cloud%20background%2C%20black%20and%20white%20with%20orange%20fire%20contrast%2C%20cinematic%20poster%20style&width=400&height=560&seq=cat-movie-6&orientation=portrait",
    rating: 8.8,
    year: 2023,
    category: "movie",
    tags: ["传记", "历史", "剧情"],
    description: "讲述了美国'原子弹之父'罗伯特·奥本海默主导制造出世界上第一颗原子弹的故事。",
    director: "克里斯托弗·诺兰",
    actors: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    duration: "180分钟",
    region: "美国",
    isHot: false,
    isNew: false,
    views: 9800000,
  },
  {
    id: "movie-7",
    title: "孤注一掷",
    englishTitle: "No More Bets",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20about%20online%20gambling%20scams%2C%20dark%20moody%20atmosphere%20with%20computer%20screens%20and%20money%2C%20tense%20cinematic%20poster%2C%20deep%20red%20and%20black%20tones%2C%20suspenseful&width=400&height=560&seq=cat-movie-7&orientation=portrait",
    rating: 7.9,
    year: 2023,
    category: "movie",
    tags: ["犯罪", "剧情", "悬疑"],
    description: "程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。",
    director: "申奥",
    actors: ["张艺兴", "金晨", "咏梅"],
    duration: "130分钟",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 14200000,
  },
  {
    id: "movie-8",
    title: "长安三万里",
    englishTitle: "Chang An",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20film%20set%20in%20Tang%20Dynasty%20ancient%20city%2C%20poets%20in%20traditional%20robes%20under%20moonlight%2C%20beautiful%20watercolor%20ink%20painting%20style%2C%20elegant%20golden%20and%20jade%20tones%2C%20poetic%20composition&width=400&height=560&seq=cat-movie-8&orientation=portrait",
    rating: 8.3,
    year: 2023,
    category: "movie",
    tags: ["动画", "历史", "诗歌"],
    description: "安史之乱后，高适回忆起自己与李白数十年的情谊，以及那个群星闪耀的大唐盛世。",
    director: "谢君伟",
    actors: ["杨天翔", "凌振赫", "吴俊全"],
    duration: "168分钟",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 8700000,
  },
  {
    id: "movie-9",
    title: "第二十条",
    englishTitle: "Article 20",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20film%20with%20a%20middle-aged%20man%20in%20courtroom%20setting%2C%20serious%20expression%2C%20dramatic%20lighting%20from%20window%2C%20cinematic%20poster%20style%2C%20muted%20blue-gray%20and%20warm%20amber%20contrast&width=400&height=560&seq=cat-movie-9&orientation=portrait",
    rating: 7.7,
    year: 2024,
    category: "movie",
    tags: ["剧情", "法律", "家庭"],
    description: "检察官韩明人到中年，本想努力进入市院工作，不料卷入一起分歧巨大的案件。",
    director: "张艺谋",
    actors: ["雷佳音", "马丽", "赵丽颖"],
    duration: "141分钟",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 10300000,
  },
  {
    id: "movie-10",
    title: "沙丘2",
    englishTitle: "Dune: Part Two",
    coverImage: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20film%20with%20desert%20planet%20landscape%2C%20young%20man%20in%20still-suit%20with%20blue%20eyes%2C%20massive%20sandworm%20in%20background%2C%20cinematic%20poster%2C%20golden%20sand%20tones%20with%20deep%20shadows%2C%20grand%20scale&width=400&height=560&seq=cat-movie-10&orientation=portrait",
    rating: 8.4,
    year: 2024,
    category: "movie",
    tags: ["科幻", "冒险", "动作"],
    description: "保罗·厄崔迪联合弗雷曼人对毁掉他家庭的阴谋者展开报复，同时阻止只有他能预见的可怕未来。",
    director: "丹尼斯·维伦纽瓦",
    actors: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森"],
    duration: "166分钟",
    region: "美国",
    isHot: false,
    isNew: false,
    views: 7600000,
  },
  {
    id: "movie-11",
    title: "年会不能停！",
    englishTitle: "Johnny Keep Walking!",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20film%20with%20office%20workers%20in%20colorful%20party%20setting%2C%20funny%20expressions%2C%20bright%20festive%20lighting%2C%20cinematic%20poster%2C%20vibrant%20red%20and%20gold%20tones&width=400&height=560&seq=cat-movie-11&orientation=portrait",
    rating: 8.2,
    year: 2023,
    category: "movie",
    tags: ["喜剧", "职场"],
    description: "钳工胡建林阴差阳错被调入集团总部，在年会上揭露了工厂贪腐，成为集团英雄。",
    director: "董润年",
    actors: ["大鹏", "白客", "庄达菲"],
    duration: "117分钟",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 8900000,
  },
  {
    id: "movie-12",
    title: "芭比",
    englishTitle: "Barbie",
    coverImage: "https://readdy.ai/api/search-image?query=Fantasy%20comedy%20film%20with%20blonde%20woman%20in%20pink%20outfit%20in%20a%20plastic%20perfect%20pink%20world%2C%20cinematic%20poster%20style%2C%20vibrant%20magenta%20and%20pastel%20tones%2C%20whimsical%20and%20fun&width=400&height=560&seq=cat-movie-12&orientation=portrait",
    rating: 7.3,
    year: 2023,
    category: "movie",
    tags: ["奇幻", "喜剧", "冒险"],
    description: "芭比因为不完美而被驱逐出芭比乐园，她来到现实世界寻找真正的人生意义。",
    director: "格蕾塔·葛韦格",
    actors: ["玛格特·罗比", "瑞恩·高斯林"],
    duration: "114分钟",
    region: "美国",
    isHot: false,
    isNew: false,
    views: 7200000,
  },
];

export const tvShows: MovieItem[] = [
  {
    id: "tv-1",
    title: "狂飙",
    englishTitle: "The Knockout",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20with%20two%20men%20facing%20each%20other%20in%20tense%20standoff%2C%20dark%20urban%20setting%2C%20rainy%20street%2C%20cinematic%20poster%20style%2C%20deep%20shadows%20with%20neon%20accents&width=400&height=560&seq=tv-1&orientation=portrait",
    rating: 9.1,
    year: 2023,
    category: "tv",
    tags: ["犯罪", "剧情", "悬疑"],
    description: "以一线刑警安欣为代表的正义力量，与黑恶势力展开长达二十年的生死较量。",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    duration: "39集",
    region: "中国大陆",
    isHot: true,
    isNew: false,
    views: 25000000,
  },
  {
    id: "tv-2",
    title: "庆余年第二季",
    englishTitle: "Joy of Life Season 2",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20with%20young%20man%20in%20elegant%20traditional%20robes%20holding%20a%20fan%2C%20ancient%20palace%20background%2C%20cinematic%20poster%2C%20rich%20gold%20and%20crimson%20tones&width=400&height=560&seq=tv-2&orientation=portrait",
    rating: 8.6,
    year: 2024,
    category: "tv",
    tags: ["古装", "权谋", "喜剧"],
    description: "范闲假死归来，面对更加复杂的朝堂局势和各方势力的明争暗斗。",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明"],
    duration: "36集",
    region: "中国大陆",
    isHot: true,
    isNew: true,
    views: 22000000,
  },
  {
    id: "tv-3",
    title: "三体",
    englishTitle: "Three-Body",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20with%20three%20suns%20in%20alien%20sky%2C%20mysterious%20cosmic%20atmosphere%2C%20cinematic%20poster%20style%2C%20deep%20space%20with%20mysterious%20energy%20waves%2C%20contemplative%20and%20grand&width=400&height=560&seq=tv-3&orientation=portrait",
    rating: 8.5,
    year: 2023,
    category: "tv",
    tags: ["科幻", "悬疑", "剧情"],
    description: "纳米科学家汪淼被卷入一场围绕神秘组织ETO的阴谋，逐渐揭开地球文明面临的外星威胁。",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾"],
    duration: "30集",
    region: "中国大陆",
    isHot: true,
    isNew: false,
    views: 18000000,
  },
  {
    id: "tv-4",
    title: "繁花",
    englishTitle: "Blossoms Shanghai",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20set%20in%201990s%20Shanghai%2C%20stylish%20man%20in%20suit%20on%20neon-lit%20street%2C%20retro%20atmosphere%2C%20cinematic%20poster%2C%20warm%20golden%20and%20deep%20green%20tones&width=400&height=560&seq=tv-4&orientation=portrait",
    rating: 8.4,
    year: 2024,
    category: "tv",
    tags: ["剧情", "年代", "商战"],
    description: "九十年代的上海，阿宝凭借改革开放的春风，从默默无闻变成黄河路上无人不晓的宝总。",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣"],
    duration: "30集",
    region: "中国大陆",
    isHot: true,
    isNew: false,
    views: 19500000,
  },
  {
    id: "tv-5",
    title: "漫长的季节",
    englishTitle: "The Long Season",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20mystery%20drama%20TV%20series%20set%20in%20northeastern%20China%20with%20autumn%20forest%20and%20train%20tracks%2C%20nostalgic%20atmosphere%2C%20cinematic%20poster%2C%20warm%20amber%20and%20rust%20tones%2C%20melancholic%20mood&width=400&height=560&seq=tv-5&orientation=portrait",
    rating: 9.0,
    year: 2023,
    category: "tv",
    tags: ["悬疑", "剧情", "家庭"],
    description: "出租车司机王响在追寻套牌车肇事者的过程中，牵扯出一段18年前的碎尸悬案。",
    director: "辛爽",
    actors: ["范伟", "秦昊", "陈明昊"],
    duration: "12集",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 16000000,
  },
  {
    id: "tv-6",
    title: "我的阿勒泰",
    englishTitle: "To the Wonder",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20slice-of-life%20drama%20TV%20series%20set%20in%20Xinjiang%20grasslands%2C%20young%20woman%20in%20traditional%20clothing%20on%20horseback%2C%20vast%20green%20meadows%20with%20snow%20mountains%2C%20cinematic%20poster%2C%20natural%20warm%20light&width=400&height=560&seq=tv-6&orientation=portrait",
    rating: 8.3,
    year: 2024,
    category: "tv",
    tags: ["剧情", "文艺", "治愈"],
    description: "生长在阿勒泰的汉族少女李文秀，在大城市追求文学梦想屡屡碰壁后回到家乡。",
    director: "滕丛丛",
    actors: ["马伊琍", "周依然", "于适"],
    duration: "8集",
    region: "中国大陆",
    isHot: false,
    isNew: true,
    views: 9500000,
  },
  {
    id: "tv-7",
    title: "莲花楼",
    englishTitle: "Mysterious Lotus Casebook",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%20TV%20drama%20with%20man%20in%20white%20robes%20holding%20sword%20in%20bamboo%20forest%2C%20elegant%20wuxia%20style%2C%20cinematic%20poster%2C%20soft%20green%20and%20white%20tones%2C%20graceful%20composition&width=400&height=560&seq=tv-7&orientation=portrait",
    rating: 8.2,
    year: 2023,
    category: "tv",
    tags: ["武侠", "悬疑", "古装"],
    description: "闻名武林的四顾门门主李相夷在一次大战后身受重伤，化名李莲花隐退江湖。",
    director: "郭虎",
    actors: ["成毅", "曾舜晞", "肖顺尧"],
    duration: "40集",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 13500000,
  },
  {
    id: "tv-8",
    title: "与凤行",
    englishTitle: "The Legend of Shen Li",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20TV%20drama%20with%20beautiful%20female%20warrior%20in%20flowing%20red%20robes%20with%20phoenix%20wings%2C%20celestial%20palace%20background%2C%20cinematic%20poster%2C%20vibrant%20crimson%20and%20gold%20tones&width=400&height=560&seq=tv-8&orientation=portrait",
    rating: 7.9,
    year: 2024,
    category: "tv",
    tags: ["仙侠", "爱情", "奇幻"],
    description: "灵界碧苍王沈璃为逃婚坠入人间，在凡间与行止相识相爱，由此展开一段跨越三界的仙侠奇缘。",
    director: "邓科",
    actors: ["赵丽颖", "林更新"],
    duration: "39集",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 12000000,
  },
];

export const varietyShows: MovieItem[] = [
  {
    id: "variety-1",
    title: "奔跑吧·生态篇",
    englishTitle: "Keep Running: Ecology",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20with%20group%20of%20celebrities%20running%20and%20laughing%20in%20nature%20setting%2C%20bright%20sunny%20day%2C%20energetic%20and%20fun%20poster%20style%2C%20vibrant%20green%20and%20yellow%20tones&width=400&height=560&seq=variety-1&orientation=portrait",
    rating: 8.0,
    year: 2024,
    category: "variety",
    tags: ["真人秀", "户外", "竞技"],
    description: "奔跑吧家族以绿色生态为主题，走遍祖国大好河山，展开一场场妙趣横生的生态挑战。",
    director: "姚译添",
    actors: ["李晨", "郑恺", "沙溢", "白鹿", "周深"],
    duration: "12期",
    region: "中国大陆",
    isHot: true,
    isNew: true,
    views: 14000000,
  },
  {
    id: "variety-2",
    title: "歌手2024",
    englishTitle: "Singer 2024",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20variety%20show%20with%20singer%20on%20grand%20stage%20holding%20microphone%2C%20dramatic%20spotlight%2C%20cinematic%20poster%2C%20deep%20blue%20and%20gold%20stage%20lighting%2C%20elegant%20performance&width=400&height=560&seq=variety-2&orientation=portrait",
    rating: 7.8,
    year: 2024,
    category: "variety",
    tags: ["音乐", "竞演", "直播"],
    description: "顶级歌手同台竞技，全程直播无修音，用最真实的声音打动观众。",
    director: "洪啸",
    actors: ["那英", "汪苏泷", "杨丞琳", "海来阿木"],
    duration: "12期",
    region: "中国大陆",
    isHot: true,
    isNew: false,
    views: 17000000,
  },
  {
    id: "variety-3",
    title: "种地吧第二季",
    englishTitle: "Become a Farmer Season 2",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20farming%20reality%20show%20with%20young%20people%20working%20in%20rice%20fields%2C%20rural%20scenery%2C%20warm%20sunlight%2C%20cinematic%20poster%20style%2C%20earthy%20green%20and%20golden%20tones%2C%20authentic%20and%20heartwarming&width=400&height=560&seq=variety-3&orientation=portrait",
    rating: 9.0,
    year: 2024,
    category: "variety",
    tags: ["劳作", "纪实", "真人秀"],
    description: "十位年轻人用190天时间在142亩土地上播种灌溉施肥收获，真实记录农耕生活。",
    director: "王征宇",
    actors: ["蒋敦豪", "鹭卓", "赵小童"],
    duration: "50期",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 11000000,
  },
  {
    id: "variety-4",
    title: "乘风2024",
    englishTitle: "Ride the Wind 2024",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20female%20singing%20competition%20variety%20show%20with%20women%20in%20stunning%20stage%20costumes%20dancing%2C%20glamorous%20stage%20lighting%2C%20cinematic%20poster%2C%20purple%20and%20silver%20tones%2C%20elegant%20and%20powerful&width=400&height=560&seq=variety-4&orientation=portrait",
    rating: 8.1,
    year: 2024,
    category: "variety",
    tags: ["音乐", "竞演", "女团"],
    description: "30位30+姐姐重新出发，通过舞台竞演展现成熟女性的魅力和力量。",
    director: "任洋",
    actors: ["戚薇", "韩雪", "陈丽君"],
    duration: "12期",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 10500000,
  },
  {
    id: "variety-5",
    title: "哈哈哈哈哈第四季",
    englishTitle: "Hahahahaha Season 4",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20travel%20variety%20show%20with%20comedians%20laughing%20on%20road%20trip%2C%20scenic%20mountain%20background%2C%20fun%20and%20casual%20poster%2C%20bright%20blue%20sky%20and%20warm%20sunlight%2C%20joyful%20atmosphere&width=400&height=560&seq=variety-5&orientation=portrait",
    rating: 7.7,
    year: 2024,
    category: "variety",
    tags: ["旅行", "喜剧", "真人秀"],
    description: "五哈旅行团踏上全新的公路旅程，沿途体验各地风土人情，欢笑不断。",
    director: "王征宇",
    actors: ["邓超", "陈赫", "鹿晗", "范志毅"],
    duration: "12期",
    region: "中国大陆",
    isHot: false,
    isNew: true,
    views: 9800000,
  },
  {
    id: "variety-6",
    title: "令人心动的offer第五季",
    englishTitle: "An Exciting Offer Season 5",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20workplace%20observation%20variety%20show%20with%20young%20professionals%20in%20modern%20office%2C%20serious%20and%20focused%2C%20cinematic%20poster%2C%20clean%20white%20and%20navy%20tones%2C%20professional%20atmosphere&width=400&height=560&seq=variety-6&orientation=portrait",
    rating: 8.3,
    year: 2023,
    category: "variety",
    tags: ["职场", "观察", "真人秀"],
    description: "8名怀揣律师梦想的法学院学生在顶级律所实习，争取最终的转正offer。",
    director: "陈伟",
    actors: ["何炅", "撒贝宁", "周深"],
    duration: "10期",
    region: "中国大陆",
    isHot: false,
    isNew: false,
    views: 8200000,
  },
];

export const animeShows: MovieItem[] = [
  {
    id: "anime-1",
    title: "鬼灭之刃 柱训练篇",
    englishTitle: "Demon Slayer: Hashira Training Arc",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20anime%20with%20young%20swordsman%20in%20traditional%20uniform%20wielding%20katana%20with%20water%20effects%2C%20dynamic%20action%20pose%2C%20anime%20poster%20style%2C%20vibrant%20blue%20and%20crimson%20tones&width=400&height=560&seq=anime-1&orientation=portrait",
    rating: 9.2,
    year: 2024,
    category: "anime",
    tags: ["热血", "战斗", "冒险"],
    description: "灶门炭治郎为了参加柱训练，与其他鬼杀队员一起接受九柱的严酷训练。",
    director: "外崎春雄",
    actors: ["花江夏树", "鬼头明里", "下野纮"],
    duration: "8集",
    region: "日本",
    isHot: true,
    isNew: true,
    views: 15500000,
  },
  {
    id: "anime-2",
    title: "葬送的芙莉莲",
    englishTitle: "Frieren: Beyond Journey's End",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20fantasy%20anime%20with%20elf%20mage%20girl%20walking%20through%20flower%20field%20at%20sunset%2C%20melancholic%20and%20beautiful%20atmosphere%2C%20anime%20poster%20style%2C%20soft%20golden%20and%20lavender%20tones&width=400&height=560&seq=anime-2&orientation=portrait",
    rating: 9.4,
    year: 2023,
    category: "anime",
    tags: ["奇幻", "冒险", "治愈"],
    description: "打倒魔王后，长寿的精灵魔法使芙莉莲踏上了解人类的旅途。",
    director: "斋藤圭一郎",
    actors: ["种崎敦美", "冈本信彦", "东地宏树"],
    duration: "28集",
    region: "日本",
    isHot: true,
    isNew: false,
    views: 13200000,
  },
  {
    id: "anime-3",
    title: "迷宫饭",
    englishTitle: "Delicious in Dungeon",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20fantasy%20cooking%20anime%20with%20adventurers%20cooking%20monsters%20in%20dungeon%2C%20whimsical%20and%20fun%2C%20anime%20poster%20style%2C%20warm%20earthy%20tones%20with%20food%20closeups&width=400&height=560&seq=anime-3&orientation=portrait",
    rating: 8.7,
    year: 2024,
    category: "anime",
    tags: ["奇幻", "美食", "冒险"],
    description: "冒险者莱欧斯一行人深入迷宫，为了节省开支决定将迷宫中的魔物做成美食。",
    director: "宫岛善博",
    actors: ["熊谷健太郎", "千本木彩花", "泊明日菜"],
    duration: "24集",
    region: "日本",
    isHot: false,
    isNew: true,
    views: 8700000,
  },
  {
    id: "anime-4",
    title: "间谍过家家第二季",
    englishTitle: "Spy x Family Season 2",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20spy%20comedy%20anime%20with%20family%20of%20three%20in%20formal%20attire%20posing%20together%2C%20elegant%20and%20playful%2C%20anime%20poster%20style%2C%20warm%20beige%20and%20burgundy%20tones&width=400&height=560&seq=anime-4&orientation=portrait",
    rating: 8.9,
    year: 2023,
    category: "anime",
    tags: ["喜剧", "间谍", "家庭"],
    description: "为了执行任务，间谍父亲、杀手母亲和超能力女儿组成的虚假家庭继续上演日常。",
    director: "古桥一浩",
    actors: ["江口拓也", "种崎敦美", "早见沙织"],
    duration: "12集",
    region: "日本",
    isHot: false,
    isNew: false,
    views: 11500000,
  },
  {
    id: "anime-5",
    title: "我推的孩子第二季",
    englishTitle: "Oshi no Ko Season 2",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20drama%20anime%20about%20idols%20and%20entertainment%20industry%2C%20colorful%20stage%20lights%20with%20characters%20in%20idol%20costumes%2C%20anime%20poster%20style%2C%20vibrant%20pink%20and%20purple%20tones&width=400&height=560&seq=anime-5&orientation=portrait",
    rating: 8.5,
    year: 2024,
    category: "anime",
    tags: ["偶像", "剧情", "悬疑"],
    description: "阿库亚和露比进入演艺圈追逐梦想，同时调查母亲星野爱之死的真相。",
    director: "平牧大辅",
    actors: ["大冢刚央", "伊驹百合绘", "潘惠美"],
    duration: "13集",
    region: "日本",
    isHot: false,
    isNew: false,
    views: 9800000,
  },
  {
    id: "anime-6",
    title: "进击的巨人 最终季 完结篇",
    englishTitle: "Attack on Titan Final Season Part 3",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20anime%20with%20massive%20titans%20destroying%20city%2C%20soldiers%20with%20ODM%20gear%20flying%2C%20epic%20apocalyptic%20scene%2C%20anime%20poster%2C%20dark%20brown%20and%20crimson%20tones&width=400&height=560&seq=anime-6&orientation=portrait",
    rating: 9.0,
    year: 2023,
    category: "anime",
    tags: ["热血", "战斗", "黑暗"],
    description: "艾伦发动地鸣，曾经的伙伴们为了阻止灭世而做出最后的选择。",
    director: "林祐一郎",
    actors: ["梶裕贵", "石川由依", "井上麻里奈"],
    duration: "2集",
    region: "日本",
    isHot: false,
    isNew: false,
    views: 10500000,
  },
];

export const allMovies: MovieItem[] = [
  ...heroMovies,
  ...categoryMovies,
  ...tvShows,
  ...varietyShows,
  ...animeShows,
];

export const hotRanking: MovieItem[] = [...(allMovies.filter(m => m.isHot).sort((a, b) => b.views - a.views).slice(0, 10))];

export const latestReleases: MovieItem[] = [...(allMovies.filter(m => m.isNew).sort((a, b) => b.year - a.year).slice(0, 10))];

export const getMoviesByCategory = (category: string): MovieItem[] => {
  if (category === "all") return allMovies;
  return allMovies.filter(m => m.category === category);
};

export const categories = [
  { slug: "movie", name: "电影", icon: "ri-film-line" },
  { slug: "tv", name: "电视剧", icon: "ri-tv-line" },
  { slug: "variety", name: "综艺", icon: "ri-live-line" },
  { slug: "anime", name: "动漫", icon: "ri-rocket-line" },
];